import moment from 'moment';
import { useCallback, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { hideConnectionsHubPopup, showConnectionsHubPopup } from '~/actions';
import { useAppSelector } from '~/hooks/useAppSelector';
import { useUserSelector } from '~/hooks/useUserSelector';

const EXPIRATION_DATE = '2025-10-30';

export const useRecommendedProsFeature = () => {
  const dispatch = useDispatch();
  const user = useUserSelector();
  const isRecommendedProsFeatureNew = useAppSelector((state) => state.user.showConnectionsHubPopup);

  const isExpired = moment().startOf('day').isAfter(EXPIRATION_DATE);

  useEffect(() => {
    const popupSeen = localStorage.getItem(`isNewToYouFeatureNew-${user?.id}`);
    if (!popupSeen && !isExpired) {
      dispatch(showConnectionsHubPopup());
    }
  }, [dispatch, user?.id, isExpired]);

  const setRecommendedProsFeatureSeen = useCallback(() => {
    localStorage.setItem(`isNewToYouFeatureNew-${user?.id}`, 'false');
    dispatch(hideConnectionsHubPopup());
  }, [dispatch, user?.id]);

  return {
    isRecommendedProsFeatureNew,
    setRecommendedProsFeatureSeen,
  };
};
